import styled, { css } from 'styled-components/macro';

export const Container = styled.div`
  display: inline-block;
  vertical-align: middle;
  cursor: pointer;
`;

export const Icon = styled.svg`
  fill: none;
  stroke: ${({ theme }) => theme.colors.checkboxStrokeColor};
  stroke-width: 3px;
  position: absolute;
  width: 15px;
  top: 0;
  left: 0;
`;

export const CheckboxInput = styled.input.attrs({
  type: 'checkbox',
})`
  border: 0;
  clip: rect(0 0 0 0);
  clippath: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;

interface ICheckbox {
  checked?: boolean;
  disabled?: boolean;
  isBigVariant?: boolean;
}

export const CheckboxDiv = styled.div<ICheckbox>`
  width: 16px;
  height: 16px;
  background: ${({ checked, theme }) => (checked ? theme.colors.green.dark : 'transparent')};
  border-radius: 4px;
  border: 1px solid
    ${({ checked, theme }) => (checked ? theme.colors.green.dark : theme.colors.gray[2])};
  transition: all 180ms;
  box-sizing: border-box;
  position: relative;

  &:hover {
    border: 1px solid ${({ theme }) => theme.colors.green.dark};
  }

  ${({ disabled, theme }) =>
    disabled &&
    css`
      cursor: not-allowed;
      border: 1px solid ${theme.colors.gray[2]};
      background: ${theme.colors.gray[3]};

      &:hover {
        border: 1px solid ${theme.colors.gray[2]};
      }

      ${Icon} {
        stroke: ${theme.colors.gray[2]};
      }
    `};

  ${({ isBigVariant, checked, theme }) =>
    isBigVariant &&
    css`
      width: 20px;
      height: 20px;
      background: ${checked ? theme.colors.green.dark : theme.colors.gray[7]};
      border-radius: 2px;

      & > svg {
        width: 19px;
      }
    `};

  ${CheckboxInput}:hover + & {
    border: 1px solid ${({ theme }) => theme.colors.green.default};
    transition: all 180ms;
  }

  ${Icon} {
    visibility: ${({ checked }) => (checked ? 'visible' : 'hidden')};
  }
`;
